import Cookies from 'react-cookies'
import * as Const from "../config/const";

export default class Post {
    constructor(post){
        const language = Cookies.load(Const.hash.cookie_lang) === 'pt-br'
        this.id = post.pos_id
        this.title = language?post.pos_titulo_pt:post.pos_titulo_en
        this.date = post.pos_data
        this.description = language?post.pos_corpo_pt:post.pos_corpo_en
        this.image_link = Const.defaults.image_base_url+(language?post.pos_imagem_pt:post.pos_imagem_en)
        this.video_link = language?post.pos_link_video_pt:post.pos_link_video_en
    }
}


// WEBPACK FOOTER //
// ./src/models/posts.js